import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { option_type, string_type, list_type, equals } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { Note$reflection, TroubleTicketPOST$reflection, TroubleTicketGET$reflection } from "./Model.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";

export function loadTroubleTickets() {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, "/Telenor/TroubleTicket/"));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1) => {
            const str = arg_1;
            return equals(list_type(TroubleTicketGET$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(TroubleTicketGET$reflection()), arg, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(TroubleTicketGET$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function refreshTroubleTicket(troubleTicketId) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Telenor/TroubleTicket/%s"))(troubleTicketId)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(TroubleTicketGET$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(TroubleTicketGET$reflection(), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(TroubleTicketGET$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function createTroubleTicket(dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, "/Telenor/TroubleTicket/"));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1) => {
            const str = arg_1;
            return equals(TroubleTicketGET$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(TroubleTicketGET$reflection(), arg, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(TroubleTicketPOST$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function createNote(troubleTicketId, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Telenor/TroubleTicket/%s/Note/"))(troubleTicketId)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(Note$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(Note$reflection(), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(Note$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function updateNote(troubleTicketId, noteId, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Telenor/TroubleTicket/%s/Note/%s/"))(troubleTicketId)(noteId)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(Note$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(Note$reflection(), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(Note$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(2), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(Note$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

